import API from '@/apis'
const servicestateData = {
    loading:false,
    processing:false,   //用于在线更新、启动服务、停止服务
    aidRunState:false,
    clientRunState:false,
    lastState:{
        "windows_version": null,
        "windows_service_name": null,
        "install_file_path": null,
        "lanip": null,
        "ip": null,
        "version": null,
        "last_runtime": null,
    }
}
const state = () => ({
    servicestate: Object.assign({}, servicestateData)
})
const getters = {
    aidRunState: state => state.servicestate.aidRunState,
    clientRunState: state => state.servicestate.clientRunState,
    lastState: state => state.servicestate.lastState,
    loading: state => state.servicestate.loading,
    processing: state => state.servicestate.processing,
}
const mutations = {
    update_service_status_main(state,data){
        state.servicestate.clientRunState = data.success || false;
        state.servicestate.lastState = data.data;
    },
    update_service_status_aid(state,data){
        state.servicestate.aidRunState = data.success || false;
    },
    //更新主程序状态
    changeClientRunState(state,data){
        state.servicestate.clientRunState = data
    },

    //刷新状态
    refresh_status(state,data){
        state.servicestate.lastState = {
            ...state.servicestate.lastState,
            ...data
        }
    }
}
const actions = {
    async ['fetch-client']({state,dispatch, rootState,commit}){
        if(state.servicestate.loading == true) return
        let msg = {command: "get_aid__status", message: {}, to: "aid"}
        dispatch('channel/socket_send', msg, {root: true})
        let msg2 = {command: "get_client__status", message: {}, to: "client"}
        dispatch('channel/socket_send', msg2, {root: true})
        state.servicestate.loading = true

    },
    async ['return_client_get__service_status_main'] ({state,commit}, payload){
        state.servicestate.loading = false
        commit('update_service_status_main',payload)
    },
    async ['return_client_get__service_status_aid'] ({state,commit}, payload){
        state.servicestate.loading = false
        commit('update_service_status_aid',payload)
    },

    async ['return_client_get__main_state'] ({state,dispatch,commit}, payload){
        if(payload.success){
            dispatch('response/success-tip', { message: '程序响应成功' }, { root: true })
            commit('refresh_status',payload.data)
        } else {
            dispatch('response/error-tip', { message: '程序响应失败，请稍后重试，或联系管理员。' }, { root: true })
        }
        state.servicestate.processing = false
    },

    //检测是否有新版本
    async ['check_update_edi']({state,dispatch,commit}){
        if(state.servicestate.processing == true) return
        dispatch('response/info-tip', { message: '正在升级...' }, { root: true })
        state.servicestate.processing = true
        let msg = {command: "post_aid__update_main_program", message: {}, to: "aid"}
        dispatch('channel/socket_send', msg, {root: true})
    },
    ['return_update_main_program']({state,dispatch,commit}, payload){
        if(payload.success){
            dispatch('response/success-tip', { message: payload.data.length ? payload.data : '升级成功' }, { root: true })
            dispatch("fetch-client");
        } else {
            dispatch('response/error-tip', { message: payload.data.length ? payload.data : '升级成功请稍后重试，或联系管理员。' }, { root: true })
        }
        state.servicestate.processing = false
    },

    async ['return_update_main_program_online'] ({state,dispatch,commit}, payload){
        if(payload.success){
            dispatch('response/success-tip', { message: payload.data.length ? payload.data : '更新成功' }, { root: true })
            dispatch("fetch-client");
        } else {
            dispatch('response/error-tip', { message: payload.data.length ? payload.data : '更新失败请稍后重试，或联系管理员。' }, { root: true })
        }
        state.servicestate.processing = false
    },

    async ['start_edi']({state,dispatch, rootState}){
        if(state.servicestate.processing == true) return
        dispatch('response/info-tip', { message: '正在启动...' }, { root: true })
        state.servicestate.processing = true

        let msg = {command: "post_aid__running_main_program", message: {}, to: "aid"}
        dispatch('channel/socket_send', msg, {root: true})
    },
    async ['return_running_main_program_online'] ({state,dispatch,commit}, payload){
        if(payload.success){
            dispatch('response/success-tip', { message: payload.data.length ? payload.data : '启动成功' }, { root: true })
            commit('changeClientRunState',true)
        } else {
            dispatch('response/error-tip', { message: payload.data.length ? payload.data : '启动失败请稍后重试，或联系管理员。' }, { root: true })
        }
        state.servicestate.processing = false
    },
    async ['stop_edi']({state,dispatch, rootState}){
        if(state.servicestate.processing == true) return
        dispatch('response/info-tip', { message: '正在停止...' }, { root: true })
        state.servicestate.processing = true
        let msg = {command: "post_aid__shutdown_main_program", message: {}, to: "aid"}
        dispatch('channel/socket_send', msg, {root: true})
    },

    async ['return_shutdown_main_program_online'] ({state,dispatch,commit}, payload){
        if(payload.success){
            dispatch('response/success-tip', { message: payload.data.length ? payload.data : '停止成功' }, { root: true })
            commit('changeClientRunState',false)
        } else {
            dispatch('response/error-tip', { message: payload.data.length ? payload.data : '停止失败请稍后重试，或联系管理员。' }, { root: true })
        }
        state.servicestate.processing = false
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
